import React from 'react'
export const About = () => {
    let myStyle = {
    height: "100vh",
    margin: "10px auto",
  };
    return (
        <div style={myStyle}>
            <h3>This is an About Component.</h3>
            
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi harum magni animi sit dicta consequuntur, labore voluptatem facilis aliquam excepturi. Dolor eius necessitatibus unde modi obcaecati tenetur accusantium neque dicta.</p>

        </div>
    )
}